import { useFormContext, Controller } from 'react-hook-form';
import { Box, InputAdornment, TextField } from '@mui/material';
import { stripHash, withHash } from './hexColor';

type ColorPickerProps = {
  name: string;
  label?: string;
  helperText?: React.ReactNode;
  disabled?: boolean;
};

const ColorPicker = ({ name, label, helperText, disabled }: ColorPickerProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          value={stripHash(field.value)}
          onChange={(e) => field.onChange(withHash(e.target.value))}
          label={label}
          placeholder="000000"
          fullWidth
          disabled={disabled}
          error={!!error}
          helperText={error?.message || helperText}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Box
                    component="input"
                    type="color"
                    value={field.value || '#000000'}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      field.onChange(e.target.value)
                    }
                    disabled={disabled}
                    sx={{
                      width: 28,
                      height: 28,
                      p: 0,
                      border: 1,
                      borderColor: 'divider',
                      borderRadius: 1,
                      cursor: disabled ? 'default' : 'pointer',
                      bgcolor: 'transparent',
                      '&::-webkit-color-swatch-wrapper': { p: 0 },
                      '&::-webkit-color-swatch': {
                        border: 'none',
                        borderRadius: 3,
                      },
                      '&::-moz-color-swatch': {
                        border: 'none',
                        borderRadius: 3,
                      },
                    }}
                  />
                  <Box component="span" sx={{ ml: 0.75, color: 'text.secondary' }}>
                    #
                  </Box>
                </InputAdornment>
              ),
            },
          }}
        />
      )}
    />
  );
};

export default ColorPicker;
